import { API } from '~apis/axios/instance';
import { PolicyModel } from '~models/policy';
import { ResponseBaseWithData } from '~types/response';

export const getCompanyAgreements = () => {
  return API.get<ResponseBaseWithData<PolicyModel.Agreement[]>>('/api/v2/company-agreements');
};
